<template lang="pug">
.preview-image
  img(
    v-lazy="image"
    :title="title"
    :style="{ width: `${width}px`, height: `${height}px` }"
    rel="noopener"
  )
  slot
</template>

<script>
export default {
    name: 'AlbumImage',
    data() {
        return {
            maxHeight: 500
        };
    },
    props: {
        image: {
            type: Object,
            required: true
        },
        width: {
            type: Number,
            required: true
        },
        height: {
            type: Number,
            required: true
        },
        title: {
            type: String
        }
    }
};
</script>

<style lang="sass" scoped></style>
